export const API_SUCCESS_MESSAGE = "保存が完了しました。";
export const API_DELETE_SUCCESS_MESSAGE = "削除が完了しました。";
export const API_UNKNOWN_ERROR_MESSAGE = "不明なエラー";
export const PREVENT_URL = "不適切なURLです";
export const DEFAULT_TIMER = 500;
export const MAX_INTEGER = 2147483646;
export const CACHED_TIME = 10000;
export const MAXIMUM_NUMBER_VALIDATION = 9999999999999;
export const ZIP_CODE_DEBOUNCE_DELAY = 100;
export const JWT_REGEX = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;
export const RESEND_COOLDOWN_SECONDS = 60;
export const SEND_LOGIN_VERIFY_CODE_COOLDOWN_KEY = "send-login-verify-code-cooldown";
export const CENTER_TOKEN_KEY = "center-token";
export const CENTER_REFRESH_TOKEN_KEY = "center-refresh-token";
export const EXTERNAL_ID_KEY = "externalId";
export const EMAIL_KEY = "email";
export const GOOGLE_METHOD = "google";
export const RESEND_RECOVER_EMAIL_COOLDOWN_STORAGE_KEY = "resend-recover-email-cooldown-until";
export const LAST_AUTH_ROUTE_KEY = "last-auth-route";
// Last authenticated route of an external app (e.g. the RSO/visa portal), pushed
// in via the ExternalAuthBridge iframe. Stored in localStorage (not sessionStorage)
// so the top-level center tab can read what the hidden bridge iframe wrote.
export const LAST_EXTERNAL_AUTH_ROUTE_KEY = "last_external_auth_route_key";
